import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import Logo from "@/assets/img/logo.jpg";
import Storage from "@/app/core/util/Storage";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SignInFormComponent from "./SignInForm";
import RegisterFormComponent from "@/app/core/layouts/main-components/account/RegisterFormComponent";

export default function SignIn(props) {
  const [step, setStep] = useState(1);


  return (
    <div id="page-container">
      <main id="main-container">
        <div>
          <div className="row no-gutters bg-primary-op">
            <div className="hero-static col-md-6 d-flex align-items-center bg-white">
              <div className="p-3 w-100">
                <div className="mb-3 text-center">
                  <a
                    className="link-fx font-w700 font-size-h1 text-warning"
                    href="javascript:void()"
                  >
                    <img
                      src={process.env.PUBLIC_URL + "/assets/media/logo.png"}
                      style={{ maxWidth: "200px" }} />
                  </a>
                </div>
                <div className="row no-gutters justify-content-center">
                  <div className="col-sm-8 col-xl-8">
                    {step == 1 ?
                      <SignInFormComponent changeRegister={() => setStep(step + 1)} />
                      :
                      <RegisterFormComponent changeLogin={() => setStep(1)} />
                    }
                  </div>
                </div>
              </div>
            </div>

            <div
              className="hero-static col-md-6 d-none d-md-flex align-items-md-center justify-content-md-center text-md-center bg-image"
              style={{
                backgroundImage: "url('assets/media/photos/bg-intro.jpg')",
              }}
            >
              <div className="p-3">
                <p className="display-4 font-w700 text-white mb-3">
                  Bem Vindo!
                </p>
                <p className="font-size-lg font-w600 text-white-75 mb-0">
                  Reclame Rio &copy;{" "}
                  <span className="js-year-copy">
                    {new Date().getFullYear()}
                    -Desenvolvido pela{" "}
                    <a
                      className="text-white"
                      href="https://navigate.one"
                      target="_blank" rel="noreferrer"
                    >
                      Navigate
                    </a>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <ToastContainer className="toastr" />
    </div>
  );
}
